module.exports = __webpack_public_path__ + "static/media/video_mask.596d9a18.svg";